import BaseAPI from '../BaseAPI.js'

/**
 * 管理端3.0、工具平台端接口
 */
export default class ManageAPI extends BaseAPI {
    constructor() {
        super()

        this.moduleName = ''
        this.opName = "/operation" // 轮播图
        this.toolName = "/tool" // 工具
        this.dictModuleName = '/dict' // 上传文件
        this.orgModuleName = "/usercenter" // 租户管理
    }

    /**
     * 轮播图管理 获取列表
     * @param {*} query 
     * @returns 
     */
    getRotationList(query) {
        return this.ajax.get(`${this.opName}/advert/page`, query)
    }

    /**
     * 删除轮播图
     * @param {*} id
     * @returns 
     */
    removeRotation(id) {
        return this.ajax.delete(`${this.opName}/advert/${id}`)
    }

    /**
     * 添加轮播图
     * @param {*} query 
     * @returns 
     */
    addRotation(query) {
        return this.ajax.post(`${this.opName}/advert`, query)
    }

    /**
     * 轮播图详情
     * @param {*} id 
     * @returns 
     */
    rotationDetail(id) {
        return this.ajax.get(`${this.opName}/advert/${id}`)
    }

    /**
     * 编辑轮播图
     * @param {*} query 
     * @returns 
     */
    editRotation(query) {
        return this.ajax.put(`${this.opName}/advert`, query)
    }

    /**
     * 获取工具分类列表
     * @param {*} query 
     * @returns 
     */
    getTooltypeList(query) {
        return this.ajax.get(`${this.toolName}/category/page`, query)
    }

    /**
     * 添加工具分类
     * @param {*} query 
     * @returns 
     */
    addTooltype(query) {
        return this.ajax.post(`${this.toolName}/category`, query)
    }

    /**
     * 工具分类详情
     * @param {*} id 
     * @returns 
     */
    tooltypeDetail(id) {
        return this.ajax.get(`${this.toolName}/category/${id}`)
    }

    /**
     * 修改工具分类
     * @param {*} query 
     * @returns 
     */
    editTooltype(query) {
        return this.ajax.put(`${this.toolName}/category`, query)
    }

    /**
     * 删除工具分类
     * @param {*} id 
     * @returns 
     */
    removeTooltype(id) {
        return this.ajax.delete(`${this.toolName}/category/${id}`)
    }

    /**
     * 获取最受欢迎列表
     * @param {*} query 
     * @returns 
     */
    getMostpopularList(query) {
        return this.ajax.get(`${this.toolName}/popular/page`, query)
    }

    /**
     * 添加最受欢迎
     * @param {*} query 
     * @returns 
     */
    addMostpopular(query) {
        return this.ajax.post(`${this.toolName}/popular`, query)
    }

    /**
     * 修改最受欢迎
     * @param {*} query 
     * @returns 
     */
    editMostpopular(query) {
        return this.ajax.put(`${this.toolName}/popular`, query)
    }

    /**
     * 删除最受欢迎
     * @param {*} id 
     * @returns 
     */
    removeMostpopular(id) {
        return this.ajax.delete(`${this.toolName}/popular/${id}`)
    }
    /**
     * 获取意见反馈信息
     * @param {*} query 
     * @returns 
     */
    getFeedBackList(query) {
        return this.ajax.post(`/operation/feedback/page`, query)
    }
    /**
     * 是否受理意见
     * @param {*} query 
     * @returns 
     */
    feedBackHandle(query) {
        return this.ajax.post(`/operation/feedback/handle`, query)
    }
    /**
     * 添加工具公告
     * @param {*} query 
     * @returns 
     */
    addNotify(query) {
        return this.ajax.post(`/operation/notify/add`, query)
    }
    /**
     * 工具公告列表
     * @param {*} query 
     * @returns 
     */
    pageNotify(query) {
        return this.ajax.post(`/operation/notify/page`, query)
    }
    /**
     * 删除工具公告
     * @param {*} query 
     * @returns 
     */
    delNotify(id) {
        return this.ajax.get(`/operation/notify/delById/${id}`)
    }
    /**
     * 删除工具公告
     * @param {*} query 
     * @returns 
     */
    editNotify(query) {
        return this.ajax.post(`/operation/notify/edit`,query)
    }

    /**
     * 获取工具列表
     * @param {*} query 
     * @returns 
     */
    getToolList(query) {
        return this.ajax.get(`${this.toolName}/tool/page`, query)
    }

    /**
     * 添加工具
     * @param {*} query 
     * @returns 
     */
    addToolData(query) {
        return this.ajax.post(`${this.toolName}/tool`, query)
    }

    /**
     * 编辑工具
     * @param {*} query 
     * @returns 
     */
    editToolData(query) {
        return this.ajax.put(`${this.toolName}/tool`, query)
    }

    /**
     * 获取工具详情 管理端
     * @param {*} id 
     * @returns 
     */
    toolDetailInfo(id) {
        return this.ajax.get(`${this.toolName}/tool/${id}`)
    }

    /**
     * 删除工具
     * @param {*} id 
     * @returns 
     */
    removeToolData(id) {
        return this.ajax.delete(`${this.toolName}/tool/${id}`)
    }

    /**
     * 获取版本列表
     * @param {*} query 
     * @returns 
     */
    getVersionList(query) {
        return this.ajax.get(`${this.toolName}/version/page`, query)
    }

    /**
     * 新增版本
     * @param {*} query 
     * @returns 
     */
    addVersion(query) {
        return this.ajax.post(`${this.toolName}/version`, query)
    }

    /**
     * 编辑版本
     * @param {*} query 
     * @returns 
     */
    editVersion(query) {
        return this.ajax.put(`${this.toolName}/version`, query)
    }

    /**
     * 获取版本详情 管理端
     * @param {*} id 
     * @returns 
     */
    getVersionDetail(id) {
        return this.ajax.get(`${this.toolName}/version/${id}`)
    }

    /**
     * 删除版本
     * @param {*} id 
     * @returns 
     */
    removeVersion(id) {
        return this.ajax.delete(`${this.toolName}/version/${id}`)
    }

    /**
     * 获取安装包列表
     * @param {*} query 
     * @returns 
     */
    getInstallPackageList(query) {
        return this.ajax.get(`${this.toolName}/package/ls`, query)
    }

    /**
     * 添加安装包
     * @param {*} query 
     * @returns 
     */
    addInstallPackage(query) {
        return this.ajax.post(`${this.toolName}/package`, query)
    }

    /**
     * 编辑安装包
     * @param {*} query 
     * @returns 
     */
    editInstallPackage(query) {
        return this.ajax.put(`${this.toolName}/package`, query)
    }

    /**
     * 获取安装包详情 管理端
     * @param {*} id 
     * @returns 
     */
    getInstallPackageDetail(id) {
        return this.ajax.get(`${this.toolName}/package/${id}`)
    }

    /**
     * 删除安装包
     * @param {*} id 
     * @returns 
     */
    removeInstallPackage(id) {
        return this.ajax.delete(`${this.toolName}/package/${id}`)
    }

    /**
     * 获取问答列表
     * @param {*} query 
     * @returns 
     */
    getQuestionList(query) {
        return this.ajax.get(`${this.toolName}/qa/page`, query)
    }

    /**
     * 添加问题
     * @param {*} query 
     * @returns 
     */
    addQuestion(query) {
        return this.ajax.post(`${this.toolName}/qa`, query)
    }

    /**
     * 获取问题详情 管理端
     * @param {*} id 
     * @returns 
     */
    getQuestion(id) {
        return this.ajax.get(`${this.toolName}/qa/${id}`)
    }

    /**
     * 修改问题
     * @param {*} query 
     * @returns 
     */
    editQuestion(query) {
        return this.ajax.put(`${this.toolName}/qa`, query)
    }

    /**
     * 删除问题
     * @param {*} id 
     * @returns 
     */
    removeQuestion(id) {
        return this.ajax.delete(`${this.toolName}/qa/${id}`)
    }

    /**
     * 获取会员管理列表
     * @param {*} query 
     * @returns 
     */
    getMemberList(query) {
        return this.ajax.get(`${this.opName}/member/page`, query)
    }

    /**
     * 添加会员
     * @param {*} query 
     * @returns 
     */
    addMember(query) {
        return this.ajax.post(`${this.opName}/member`, query)
    }

    /**
     * 获取会员详情 管理端
     * @param {*} id 
     * @returns 
     */
    getMemberDetail(id) {
        return this.ajax.get(`${this.opName}/member/${id}`)
    }

    /**
     * 编辑会员
     * @param {*} query 
     * @returns 
     */
    editMember(query) {
        return this.ajax.put(`${this.opName}/member`, query)
    }

    /**
     * 删除会员
     * @param {*} id 
     * @returns 
     */
    removeMember(id) {
        return this.ajax.delete(`${this.opName}/member/${id}`)
    }

    /**
     * 获取会员订单列表
     * @param {*} query 
     * @returns 
     */
    getOrderList(query) {
        return this.ajax.get(`${this.opName}/member/order/page`, query)
    }

    /**
     * 获取会员定制列表
     * @param {*} query 
     * @returns 
     */
    getCustomizaList(query) {
        return this.ajax.get(`${this.opName}/customize/page`, query)
    }

    /**
     * 获取会员定制数据详情 管理端
     * @param {*} id 
     * @returns 
     */
    customizaDetail(id) {
        return this.ajax.get(`${this.opName}/customize/${id}`)
    }

    /**
     * 会员定制审核
     * @param {*} query 
     * @returns 
     */
    customizaExamine(query) {
        return this.ajax.put(`${this.opName}/customize`, query)
    }

    /**
     * 删除会员定制
     * @param {*} id 
     * @returns 
     */
    removeCustomiza(id) {
        return this.ajax.delete(`${this.opName}/customize/${id}`)
    }

    /**
     * 上传单文件
     * @param {*} query 
     * @returns 
     */
    uploadFile(query) {
        return this.ajax.post(`${this.dictModuleName}/file/upload`, query)
    }


    // 演示的2个页面
    /**
     * 违规文档管理 列表数据
     * @param {*} query 
     * @returns 
     */
    getAlarmList(query) {
        return this.ajax.post(`${this.moduleName}/violation/pageList`, query)
    }

    /**
     * 违规词管理 获取列表
     * @param {*} query 
     * @returns 
     */
    getKeywordList(query) {
        return this.ajax.post(`${this.moduleName}/violation/keyword/pageList`, query)
    }

    /**
     * 添加违规词
     * @param {*} query 
     * @returns 
     */
    addKeywordList(query) {
        return this.ajax.post(`${this.moduleName}/violation/add`, query)
    }

    /**
     * 更改违规词
     * @param {*} query 
     * @returns 
     */
    editKeywordList(query) {
        return this.ajax.post(`${this.moduleName}/violation/changeLevel`, query)
    }

    /**
     * 删除违规词
     * @param {*} id 
     * @returns 
     */
    removeKeywordList(id) {
        return this.ajax.delete(`${this.moduleName}/violation/${id}`)
    }

    /**
     * 租户管理-获取组织列表
     * @param {*} query 
     * @returns 
     */
    getTenantList(query) {
        return this.ajax.post(`${this.orgModuleName}/organization/page/list`, query)
    }

    /**
     * 租户管理-添加组织
     * @param {*} query 
     * @returns 
     */
    addTenant(query) {
        return this.ajax.post(`${this.orgModuleName}/organization/addTenant`, query)
    }

    /** 工具使用次数统计接口 */
    getToolPageTracking(query) {
        return this.ajax.get(`${this.toolName}/tracking/tool/page`, query)
    }

    /** 获取文档库 */
    getDocumentLibrary(query) {
        return this.ajax.post("/document/search/documentCenter/search", query)
    }
    /**
     * 工具端 组织管理页面-获取组织列表
     * @returns 
     */
    toolGetOrgList(token) {
        return this.ajax.get(`${this.orgModuleName}/organization/getUserOrgList`, {}, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 修改密码
     * @returns 
     */
    toolResetPassword(newPassword, token) {
        return this.ajax.put("/usercenter/user/password", {
            oldPassword: newPassword,
            newPassword,

        }, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具更新用户信息
     */
    toolsUpdate(userInfo, token) {
        return this.ajax.put(`/usercenter/user/update`, {
            username: userInfo.username,
            sex: userInfo.sex,
            birthday: userInfo.birthday,
            email: userInfo.email
        }, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    // 工具更新用户信息
    toolsGetInfo(token) {
        return this.ajax.get(`/usercenter/user/getUserDetails`, {}, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    // 工具更新token
    toolsRefreshToken(refreshToken) {
        return this.ajax.post("/auth/oauth/token", {
            grant_type: "refresh_token",
            refresh_token: refreshToken
        }, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Authorization": "Basic bGlhbmtvbmc6MTIzNDU2"
            }
        })
    }

    /**
     * 工具端 组织管理页面-创建部门
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolCreateDep(query, token) {
        return this.ajax.post(`${this.orgModuleName}/group`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面-修改部门
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolEditDep(query, token) {
        return this.ajax.put(`${this.orgModuleName}/group/rename`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面-删除部门
     * @param {*} id 
     * @param {*} token 
     * @returns 
     */
    toolRemoveDep(id, token) {
        return this.ajax.delete(`${this.orgModuleName}/group/${id}`, {}, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 获取部门下成员
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolDepMemberList(query, token) {
        return this.ajax.post(`${this.orgModuleName}/group/member/list`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 获取组织下成员
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolOrgMemberList(query, token) {
        return this.ajax.post(`${this.orgModuleName}/organization/member/list`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 添加部门成员
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolAddDepPerson(query, token) {
        return this.ajax.post(`${this.orgModuleName}/group/addTenantUser`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 删除部门成员
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolRemoveDepPerson(query, token) {
        return this.ajax.delete(`${this.orgModuleName}/group/remove/member`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 删除组织成员
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolRemoveOrgPerson(query, token) {
        return this.ajax.put(`${this.orgModuleName}/organization/tenant/manager/remove/user`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 重置密码
     * @param {*} query 
     * @param {*} token 
     * @returns 
     */
    toolEditPassword(query, token) {
        return this.ajax.put(`${this.orgModuleName}/organization/reset/tenant/password`, query, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     *  工具端 组织管理页面- 下载导入模板
     * @returns 
     */
    toolExportOrgInfo(token) {
        const url = `${this.orgModuleName}/organization/exportOrgTemplate?access_token=${token}`
        window.location.href = '/api/v1' + url
    }

    /**
     * 工具端 组织管理页面- 导入通讯录
     * @param {*} query 
     * @returns 
     */
    toolExportUploadOrg(query, token) {
        return this.ajax.post(`${this.orgModuleName}/organization/importOrgInformation`, query, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Authorization": "Bearer " + token
            }
        })
    }

    /**
     * 工具端 组织管理页面- 获取租户详情
     * @param {*} query 
     * @returns 
     */
    toolGetUserDetail(query, token) {
        return this.ajax.get(`${this.orgModuleName}/organization/tenant/user/detail/${query.userId}/${query.orgId}`, {}, {
            headers: {
                "Authorization": "Bearer " + token
            }
        })
    }

}